export default "__VITE_ASSET__mWbUXKyk__"